import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {MenuItemType} from '@models/sidebar/menu-item-type';
import {PagesHelperService} from '@services/pages/pages-helper.service';
import {PageGlobalParameters} from '@models/pages/page-global-parameters';
import {MenuItem} from '@models/sidebar/menu-item';
import {BreadcrumbService} from '@services/breadcrumb/breadcrumb.service';

@Component({
    selector: 'scitis-page-container',
    templateUrl: './page-container.component.html',
    styleUrls: ['./page-container.component.scss'],
    standalone: false
})
export class PageContainerComponent implements OnInit {

  public pageGlobalParameters: PageGlobalParameters = new PageGlobalParameters();
  public routes: MenuItem[] = [];

  constructor(private activatedRoute: ActivatedRoute,
              private pagesHelperService: PagesHelperService,
              private breadcrumbService: BreadcrumbService) {
  }

  public get isLookerPage() {
    return this.pageGlobalParameters.pageType === MenuItemType.LOOKER_PAGE;
  }

  public get isWebGLPage() {
    return this.pageGlobalParameters.pageType === MenuItemType.WEBGL_PAGE;
  }

  ngOnInit(): void {
    this.pageGlobalParameters = this.pagesHelperService.getPageDetailsFromUrl(this.activatedRoute.snapshot.paramMap);
    this.generateRoutes(this.pageGlobalParameters.associatedMenuItem);
  }

  private generateRoutes(menuItem: MenuItem) {
    this.routes = this.breadcrumbService.generateRoutes(menuItem);
  }

}
